import { Injectable, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TRANSLOCO_SCOPE, Translation, TranslocoLoader, TranslocoService } from '@jsverse/transloco';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * Useful for waiting to complete navigation until the needed
 * lazy loaded scope translations are ready
 * @param key arbitrary key from the scoped lazy translations (without the scope)
 * @param scope scope of the translations
 */
export function translationResolver(key: string, scope: string): ResolveFn<Observable<boolean>> {
    return () => {
        const transloco = inject(TranslocoService);
        const tScope = inject(TRANSLOCO_SCOPE);
        return transloco.selectTranslate(key, {}, tScope).pipe(
            map(val => val !== `${scope}.${key}`)
        );
    };
}

@Injectable({ providedIn: 'root' })
export class TranslocoLoaderService implements TranslocoLoader {
    constructor() {}

    getTranslation(lang: string): Promise<Translation> {
        return import(`../../../assets/i18n/${lang}.json`);
    }
}
